package com.sweetlime.bingeamigo.model.types

enum class FollowType {
    FOLLOWERS,
    FOLLOWING
}